import React from 'react';
import { PackageSuggestionFormFieldFragment } from 'types/generated';
import InitialSection from './InitialSection';
import QuestionSection from './QuestionSection';
import SuggestionSection from './SuggestionSection';
import { fullScreenChildGridClasses } from '@/styles/grid';
import clsx from 'clsx';
import { PackageSuggestionProvider } from './PackageSuggestionContext';

type Props = {
  data: PackageSuggestionFormFieldFragment;
};

const renderSection = (
  data: PackageSuggestionFormFieldFragment,
  step: number,
  setStep: React.Dispatch<React.SetStateAction<number>>,
  numberOfQuestions: number,
  isEnd: boolean,
  isStart: boolean
) => {
  if (isStart) {
    return <InitialSection data={data} onStartClick={() => setStep(1)} />;
  } else if (isEnd) {
    return <SuggestionSection data={data.packageSuggestionsCollection} onStartAgainClick={() => setStep(1)} />;
  } else if (numberOfQuestions >= 1) {
    return (
      <QuestionSection
        data={data.inputFormsCollection}
        onClick={(step) => setStep(step)}
        step={step}
        numberOfQuestions={numberOfQuestions}
      />
    );
  }
  return <></>;
};

const PackageSuggestion = ({ data }: Props) => {
  const [step, setStep] = React.useState(0);
  const numberOfQuestions = data.inputFormsCollection?.items ? data.inputFormsCollection.items.length : 0;
  const isEnd = numberOfQuestions + 1 === step;
  const isStart = step <= 0;

  return (
    <PackageSuggestionProvider>
      <div
        className={`${fullScreenChildGridClasses} relative left-0 h-fit min-h-[560px] w-screen bg-white-100 transition-all md:min-h-[704px] ${clsx(
          {
            'bg-gradient-to-tr from-[#820000] to-red-100': isStart || isEnd,
            'py-32': !isStart,
          }
        )}`}
      >
        {renderSection(data, step, setStep, numberOfQuestions, isEnd, isStart)}
      </div>
    </PackageSuggestionProvider>
  );
};
export default PackageSuggestion;
